import React, { useEffect, useState } from 'react'
import { Flex, Layout, Skeleton, Typography } from 'antd'
import { colorBgAccentGraySubtlest, colorTextInverse, colorTextSubtle } from '../../../themes/primaryThemeDefault'
import { Footer, Header, Content } from 'antd/lib/layout/layout'
import ImageHeader from 'src/assets/images/header-help-page.png'
import Logo from 'src/assets/images/logo-help-page.png'
import CopyRightIcon from 'src/assets/images/copy-right-icon.png'
import { PREVIEW_HELP_PAGE } from '../../../shared/constants/localStorage.constants'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useCurrentDetailHelpPage, useHelpPage } from '../useHelpPage'
import { useRolePermission } from '../../../shared/hooks/useRolePermission'
import { EPermissions, ESubModules, EXCLUDED_HELP_PAGE_SUBMODULES } from '../../../shared/models/roleAndPermission.model'
import { menuUrls } from '../../../shared/constants/menu.constants'


interface PreviewHelpPageProps {
  mode: 'view' | 'preview'
}

const PreviewHelpPage: React.FC<PreviewHelpPageProps> = ({ mode }) => {
  const { t } = useTranslation(undefined, { useSuspense: true })
  const location = useLocation()
  const params = useParams()
  
  const id = location.pathname.replace('/help-pages', '')

  const [pageName, setPageName] = useState<string>()
  const [content, setContent] = useState<string>()
  const { getHelpPage } = useCurrentDetailHelpPage()
  const { userPermissions } = useRolePermission()
  const navigate = useNavigate()
  const { isLoading, helpPageList, getHelpPageListData } = useHelpPage()

  const loadPreviewData = () => {
    try {
      const previewData: {
        pageName: string,
        content: string
      } = JSON.parse(localStorage.getItem(PREVIEW_HELP_PAGE) || '')

      if (previewData) {
        setPageName(previewData.pageName)
        setContent(previewData.content)
      }
    } catch (e) {
      console.log('ERROR', e)
    }
  }

  const loadHelpPage = async () => {
    const res = await getHelpPageListData({})
    if (res) {
      const page = res.items.find((value: any) => value.url === id)

      if (page) {
        const res = await getHelpPage(page.mainPageId)
        if (res && res.content) {
          const submoduleCode: any = res.submoduleCodeName as ESubModules

          // @ts-ignore
          if (EXCLUDED_HELP_PAGE_SUBMODULES.includes(submoduleCode) || userPermissions[submoduleCode]?.includes(EPermissions.VIEW_ITEMS)) {
            setPageName(res.mainPageName)
            setContent(res.content)
          } else {
            navigate(menuUrls.accessDenied)
          }

        } else {
          navigate(menuUrls.pageNotFound)
        }
      } else {
        navigate(menuUrls.pageNotFound)
      }
    }
  }

  useEffect(() => {
    if (mode === 'preview') {
      loadPreviewData()
    } else {
      loadHelpPage()
    }
  }, [])

  return (
    <Layout style={{ position: 'relative' }}>
      <Flex style={{ position: 'absolute', top: 0, height: 46, width: '100%', backgroundColor: '#FFFFFF4D' }}
            justify={'center'} align={'center'}
      >
        {
          mode === 'preview' && <Typography.Text style={{ fontWeight: 600, color: colorTextInverse, fontSize: 22 }}>
            {t('HelpPage:form.label.preview')}
          </Typography.Text>
        }
      </Flex>

      <Header style={{ height: 200, backgroundImage: `url(${ImageHeader})`, backgroundSize: 'cover' }}>
        <Flex align={'center'} justify={'center'} style={{ height: '100%' }}>
          <Typography.Text style={{ fontSize: 40, fontWeight: 700, color: colorTextInverse }}>
            {t('HelpPage:form.label.helpCenter')}
          </Typography.Text>
        </Flex>
      </Header>

      {
        isLoading ?
          <Content style={{ minHeight: 'fit-content', padding: '40px 244px' }}>
            <Skeleton />
          </Content> :
          <Content style={{ minHeight: 'fit-content', padding: '40px 244px' }}>
            {/*<Typography.Text*/}
            {/*  style={{*/}
            {/*    color: '#004B91',*/}
            {/*    fontWeight: 700,*/}
            {/*    fontSize: 28,*/}
            {/*    marginBottom: 16,*/}
            {/*    lineHeight: '38px',*/}
            {/*  }}*/}
            {/*>*/}
            {/*  {pageName}*/}
            {/*</Typography.Text>*/}

            <div dangerouslySetInnerHTML={{ __html: content as any }}></div>
          </Content>
      }

      <Footer style={{ padding: 0 }}>
        <Flex justify={'space-between'} align={'center'}
              style={{ height: 56, backgroundColor: colorBgAccentGraySubtlest, padding: '0 122px' }}
        >
          <img src={Logo} alt="help page logo" style={{ height: 24 }} />

          <Typography.Text style={{ color: colorTextSubtle, fontWeight: 400, fontSize: 16 }}>
            Copyright <img style={{ transform: `translateY(2px)` }} src={CopyRightIcon} alt={'copy right icon'} /> 2024
            Bank Fraud Alert
          </Typography.Text>
        </Flex>
      </Footer>
    </Layout>
  )
}

export default PreviewHelpPage
